// ets_tracing: off
import * as T from "@effect-ts/core/Sync";
import { interpreter } from "../../HKT/index.mjs";
import { decoderApplyConfig, DecoderType, DecoderURI } from "../base/index.mjs";
import { makeDecoder } from "../common/index.mjs";
export const decoderUnknownInterpreter = /*#__PURE__*/interpreter()(() => ({
  _F: DecoderURI,
  unknown: cfg => env => new DecoderType(decoderApplyConfig(cfg === null || cfg === void 0 ? void 0 : cfg.conf)(makeDecoder(T.succeed, "unknown", (cfg === null || cfg === void 0 ? void 0 : cfg.name) || "unknown"), env, {}))
}));
//# sourceMappingURL=unknown.mjs.map